var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditorLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "274px",
    height: "50px",
    viewBox: "0 0 274 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E20804EB-D064-4524-A3C9-6A8503A15937") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Auditor-|-Profile-Dropdown",
    transform: "translate(-60.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Auditor\\u2019s-Portal",
    fontFamily: "BaiJamjuree-Medium, Bai Jamjuree",
    fontSize: 26,
    fontWeight: 400,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 84,
    y: 34
  }, "Auditor\u2019s Portal")), /*#__PURE__*/React.createElement("line", {
    x1: 63.5,
    y1: 0.5,
    x2: 64,
    y2: 48,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.302743821,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7776",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.17035,41 L10.5,41 C4.70364885,40.9936267 0.00636548898,36.290608 0,30.4871795 L0,10.5128205 C0.00636548898,4.70939201 4.70364885,0.00637326125 10.5,0 L31.5,0 C37.2963512,0.00637326125 41.9936345,4.70939201 42,10.5128205 L42,15.7692308 L33.6,15.7692308 L33.6,10.5128205 C33.6,9.35160642 32.659798,8.41025641 31.5,8.41025641 L10.5,8.41025641 C9.34020203,8.41025641 8.4,9.35160642 8.4,10.5128205 L8.4,30.4871795 C8.4,31.6483936 9.34020203,32.5897436 10.5,32.5897436 L20.32905,32.5897436 L23.17035,41 Z M32.1636,40.9789744 L32.1636,40.9789744 L29.3286,32.5897436 L31.5,32.5897436 C32.659798,32.5897436 33.6,31.6483936 33.6,30.4871795 L33.6,24.1794872 L42,24.1794872 L42,30.4871795 C41.9922504,36.0318065 37.6909168,40.6202257 32.16465,40.9789744 L32.1636,40.9789744 Z",
    id: "Subtraction_3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_1339",
    transform: "translate(25.500000, 37.500000) rotate(90.000000) translate(-25.500000, -37.500000) ",
    points: "15 37.2711559 36 30 36 37.7288441 15 45"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditorLogo);
export default __webpack_public_path__ + "static/media/auditor-logo.622ad0add639f43b569ab53dab927c1e.svg";
export { ForwardRef as ReactComponent };